var _path, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.4967 1.49097H3.21387C2.26735 1.49097 1.50006 2.25359 1.50006 3.19435V10.4329C1.50006 11.3737 2.26735 12.1363 3.21387 12.1363C3.52938 12.1363 3.78515 11.8821 3.78515 11.5685C3.78515 11.2549 3.52938 11.0007 3.21387 11.0007C2.89835 11.0007 2.64258 10.7465 2.64258 10.4329V3.19435C2.64258 2.88075 2.89835 2.62654 3.21387 2.62654H10.4967C10.8122 2.62654 11.068 2.88075 11.068 3.19435C11.068 3.50794 11.3237 3.76215 11.6392 3.76215C11.9548 3.76215 12.2105 3.50794 12.2105 3.19435C12.2105 2.25359 11.4432 1.49097 10.4967 1.49097ZM6.07023 4.32992H12.7818C13.7283 4.32992 14.4956 5.09255 14.4956 6.0333V12.704C14.4956 13.6448 13.7283 14.4074 12.7818 14.4074H6.07023C5.12372 14.4074 4.35643 13.6448 4.35643 12.704V6.0333C4.35643 5.09255 5.12372 4.32992 6.07023 4.32992ZM5.49895 12.7041C5.49895 13.0177 5.75472 13.2719 6.07023 13.2719H12.7818C13.0973 13.2719 13.3531 13.0177 13.3531 12.7041V6.0333C13.3531 5.7197 13.0973 5.46549 12.7818 5.46549H6.07023C5.75472 5.46549 5.49895 5.7197 5.49895 6.0333V12.7041Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    height: 14,
    id: "mask0_4409_21734",
    maskUnits: "userSpaceOnUse",
    width: 14,
    x: 1,
    y: 1
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.4967 1.49097H3.21387C2.26735 1.49097 1.50006 2.25359 1.50006 3.19435V10.4329C1.50006 11.3737 2.26735 12.1363 3.21387 12.1363C3.52938 12.1363 3.78515 11.8821 3.78515 11.5685C3.78515 11.2549 3.52938 11.0007 3.21387 11.0007C2.89835 11.0007 2.64258 10.7465 2.64258 10.4329V3.19435C2.64258 2.88075 2.89835 2.62654 3.21387 2.62654H10.4967C10.8122 2.62654 11.068 2.88075 11.068 3.19435C11.068 3.50794 11.3237 3.76215 11.6392 3.76215C11.9548 3.76215 12.2105 3.50794 12.2105 3.19435C12.2105 2.25359 11.4432 1.49097 10.4967 1.49097ZM6.07023 4.32992H12.7818C13.7283 4.32992 14.4956 5.09255 14.4956 6.0333V12.704C14.4956 13.6448 13.7283 14.4074 12.7818 14.4074H6.07023C5.12372 14.4074 4.35643 13.6448 4.35643 12.704V6.0333C4.35643 5.09255 5.12372 4.32992 6.07023 4.32992ZM5.49895 12.7041C5.49895 13.0177 5.75472 13.2719 6.07023 13.2719H12.7818C13.0973 13.2719 13.3531 13.0177 13.3531 12.7041V6.0333C13.3531 5.7197 13.0973 5.46549 12.7818 5.46549H6.07023C5.75472 5.46549 5.49895 5.7197 5.49895 6.0333V12.7041Z",
    fill: "white",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4409_21734)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    height: 15.9026,
    width: 16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.96a3d8e97191c48222d4b81982c561f0.svg";
export { ForwardRef as ReactComponent };